import { STORAGE_PREFIX as prefix } from './redux';
//import * as constants from './constants';

export const getGameTitleOrSector = (state) =>
  state[prefix].game_title_or_sector;
